// extracted by mini-css-extract-plugin
module.exports = {"select":"MySelect_select__2_qkH"};